import { useNavigateToRoute } from '@/components/navigation/useNavigateToRoute';
import { ENTITY_TYPES } from '@/modules/entities/entities.constants';
import { useHouseholdDetailsContext } from '@/modules/household/contexts/householdDetails.context';
import { GratDesignerStages, ROUTE_KEYS } from '@/navigation/constants';
import { EntityStage } from '@/types/schema';

export function useNavigateToGRATPageByStage() {
  const { navigate } = useNavigateToRoute();
  const { householdId } = useHouseholdDetailsContext();

  return (stage: EntityStage, entityId: string) => {
    if (!householdId) return;
    switch (stage) {
      case EntityStage.ReadyForProposal:
      // falls through
      case EntityStage.Draft:
        return navigate(ROUTE_KEYS.HOUSEHOLD_ENTITY_DESIGNER, {
          entityId,
          householdId: householdId,
          designerStage: GratDesignerStages.STRUCTURING,
          entityType: ENTITY_TYPES.GRAT,
        });
      case EntityStage.Implementation:
        return navigate(ROUTE_KEYS.HOUSEHOLD_ENTITY_IMPLEMENTATION, {
          entityId,
          householdId: householdId,
        });
      default:
        // unexpected, but stranger things have happened
        return navigate(ROUTE_KEYS.HOUSEHOLD_ENTITY_DETAILS, {
          entityId,
          householdId: householdId,
        });
    }
  };
}
